/* eslint-disable */
export const maxLifetime = 0

export default [
[ 0, 100000 ],
[ 1, 97408 ],
[ 2, 97259 ],
[ 3, 97160 ],
[ 4, 97082 ],
[ 5, 97015 ],
[ 6, 96955 ],
[ 7, 96900 ],
[ 8, 96848 ],
[ 9, 96801 ],
[ 10, 96758 ],
[ 11, 96718 ],
[ 12, 96678 ],
[ 13, 96632 ],
[ 14, 96576 ],
[ 15, 96503 ],
[ 16, 96413 ],
[ 17, 96306 ],
[ 18, 96185 ],
[ 19, 96051 ],
[ 20, 95908 ],
[ 21, 95755 ],
[ 22, 95595 ],
[ 23, 95426 ],
[ 24, 95263 ],
[ 25, 95106 ],
[ 26, 94957 ],
[ 27, 94816 ],
[ 28, 94679 ],
[ 29, 94542 ],
[ 30, 94401 ],
[ 31, 94254 ],
[ 32, 94100 ],
[ 33, 93939 ],
[ 34, 93769 ],
[ 35, 93589 ],
[ 36, 93395 ],
[ 37, 93185 ],
[ 38, 92956 ],
[ 39, 92705 ],
[ 40, 92427 ],
[ 41, 92121 ],
[ 42, 91782 ],
[ 43, 91406 ],
[ 44, 90991 ],
[ 45, 90533 ],
[ 46, 90028 ],
[ 47, 89472 ],
[ 48, 88859 ],
[ 49, 88178 ],
[ 50, 87424 ],
[ 51, 86589 ],
[ 52, 85673 ],
[ 53, 84678 ],
[ 54, 83607 ],
[ 55, 82463 ],
[ 56, 81247 ],
[ 57, 79952 ],
[ 58, 78569 ],
[ 59, 77083 ],
[ 60, 75485 ],
[ 61, 73771 ],
[ 62, 71944 ],
[ 63, 70009 ],
[ 64, 67970 ],
[ 65, 65834 ],
[ 66, 63603 ],
[ 67, 61280 ],
[ 68, 58871 ],
[ 69, 56384 ],
[ 70, 53825 ],
[ 71, 51204 ],
[ 72, 48526 ],
[ 73, 45797 ],
[ 74, 43022 ],
[ 75, 40207 ],
[ 76, 37366 ],
[ 77, 34513 ],
[ 78, 31658 ],
[ 79, 28814 ],
[ 80, 25993 ],
[ 81, 23204 ],
[ 82, 20466 ],
[ 83, 17827 ],
[ 84, 15345 ],
[ 85, 13065 ],
[ 86, 10969 ],
[ 87, 9071 ],
[ 88, 7378 ],
[ 89, 5888 ],
[ 90, 4600 ],
[ 91, 3514 ],
[ 92, 2626 ],
[ 93, 1917 ],
[ 94, 1369 ],
[ 95, 956 ],
[ 96, 656 ],
[ 97, 440 ],
[ 98, 288 ],
[ 99, 185 ],
[ 100, 115 ],
[ 101, 70 ],
[ 102, 41 ],
[ 103, 24 ],
[ 104, 13 ],
[ 105, 7 ],
[ 106, 4 ],
[ 107, 2 ],
[ 108, 1 ],
[ 109, 0 ],
[ 110, 0 ]
]
